import React, { forwardRef, Fragment, useEffect, useState, useCallback, useRef, useMemo } from 'react';
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  DialogContent,
  useMediaQuery,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Feed from '../feed';
import { DOMAIN } from '../../config';
import CustomizedProgressBars from '../common/loading';
import AppSnackbar from "../common/appSnackbar.jsx";
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { motion } from 'framer-motion';
import theme from '../../styles/theme';
import FilterMenuButton from '../common/FilterMenuButton.jsx';
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

export default function SearchDialog({ openSearch = false, setOpenSearch, chipTitle }) {
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const [latest, setLatest] = useState([]);
  const [loading, setLoading] = useState(false);
  const [empty, setEmpty] = useState(false);


  const [filterResult, setFilterResult] = useState({
    sort: "最新发布",
    categories: [],
  });
  const [reset, setReset] = useState(false);

  const touchStartRef = useRef(0);

  const handleTouchStart = (event) => {
    touchStartRef.current = event.touches[0].clientX;
  };
  const handleTouchEnd = (event) => {
    const swipeDistance = touchStartRef.current - event.changedTouches[0].clientX;
    if (swipeDistance > 120) setOpenSearch(false);
  };

  const isRemark = [
    "淫妻", "淫妻绿帽", "东京热", "Sperm", "夜未央", "夜未央夫妻", "周排行榜", "科幻", "ED Mosaic"
  ].includes(chipTitle);

  const handleClose = () => setOpenSearch(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const url = `${DOMAIN}ywyminiappbot/search?caption=${encodeURIComponent(chipTitle)}&page=1`;
      const res = await fetch(url);
      const data = await res.json();
      if (!data || data.length === 0) {
        setLatest([]);
        setEmpty(true);
      } else {
        setLatest(data);
        setEmpty(false);
      }
    } catch (err) {
      console.error("加载失败:", err);
      setEmpty(true);
    } finally {
      setLoading(false);
    }
  }, [chipTitle]);

  useEffect(() => {
    if (openSearch) fetchData();
  }, [openSearch, fetchData]);

  const handleFilterChange = (newFilter) => {
    setFilterResult(newFilter);
    const filterStr = `filter+${encodeURIComponent(JSON.stringify(newFilter))}`;
    setReset(filterStr); // Feed 内部会监听 reset
  };

  // ✅ memo 化 feed URL，避免每次 render 都生成新字符串
  const feedUrl = useMemo(() => {
    const baseUrl = `${DOMAIN}ywyminiappbot/search?caption=${encodeURIComponent(chipTitle || "")}`;
    const params = new URLSearchParams();
    params.append("sort", filterResult?.sort || "最新发布");
    if (filterResult?.categories?.length > 0) {
      params.append("categories", filterResult.categories.join(","));
    }
    return `${baseUrl}?${params.toString()}`;
  }, [chipTitle, filterResult]);


  return (
    <Fragment>
      <Dialog
        fullScreen
        open={openSearch}
        onClose={handleClose}
        TransitionComponent={Transition}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        PaperProps={{ onTouchStart: handleTouchStart, onTouchEnd: handleTouchEnd }}
      >
        <AppSnackbar message={"向左 👈 滑动可快速关闭本页面"} vertical={"bottom"} />

        <AppBar
          position="sticky"
          elevation={0}
          sx={{
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            backgroundColor: 'rgba(255,255,255,0.25)',
            color: '#000'
          }}
        >
          <Toolbar sx={{ minHeight: 45, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {/* 左侧：关闭按钮 + 标题 */}
            <motion.div
              initial={{ x: '100vw', opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ type: 'spring', stiffness: 300, damping: 30 }}
              style={{ display: 'flex', alignItems: 'center', gap: 8 }}
            >
              <IconButton edge="start" color="inherit" onClick={handleClose}>
                <CloseIcon fontSize="small" />
              </IconButton>
              <Typography variant="subtitle1" sx={{ fontWeight: 500, fontSize: 16 }}>
                {chipTitle === "夜未央" ? `${chipTitle}夫妻自拍` : chipTitle}
              </Typography>
            </motion.div>

            {/* 右侧：FilterMenuButton */}
            <FilterMenuButton onChange={handleFilterChange} CATEGORY_OPTIONS={[]} />
          </Toolbar>
        </AppBar>


        <DialogContent
          style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, padding: 0, paddingTop: 45, overflowY: 'auto' }}
        >
          {loading && <CustomizedProgressBars />}

          {!loading && empty && (
            <Box sx={{ display: "flex", justifyContent: "center", flexFlow: "row", padding: "200px 0", color: "#999" }}>
              <SearchOffIcon />
              <Typography variant='h6' fontSize={14}>
                没有此内容，我们会尽快发布...
              </Typography>
            </Box>
          )}

          {/* ✅ 保持 Feed 永远挂载，reset 控制内部逻辑 */}
          <Feed
            matches={matches}
            latest={latest || []}
            setLatest={setLatest}
            title={chipTitle}
            remark={isRemark}
            fetchUrl={feedUrl}
            reset={reset}
          />
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
